const filterOptions = (options, filterValue) => {
  const filterBy = filterValue.toLowerCase();

  return options.reduce(
    (acc, current) =>
      String(current.label).toLowerCase().includes(filterBy)
        ? acc.concat(current)
        : acc,
    [],
  );
};

export default filterOptions;
